<div [style.width.px]="header.width" class="fw-medium">
  @if (header.isSortable) {
    <div
      [pSortableColumn]="header.key"
      class="d-flex align-items-center justify-content-between grid-header rounded-1 sorted mb-1">
      {{ header.label }}
      <p-sortIcon class="small sort-icon" field="{{ header.key }}" />
    </div>
  }
  @if (!header.isSortable) {
    {{ header.label }}
  }
</div>
